import { IntegrityMonitorAddCustomRulePanelController } from '../controller/IntegrityMonitorAddCustomRulePanelController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';

export class IntegrityMonitorAddCustomRulePanelWebComponent extends BaseWebComponentElement {
  public controller!: IntegrityMonitorAddCustomRulePanelController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrityMonitorAddCustomRulePanelController,
    });
  }

  public reset(): void {
    this.controller.view.dom.$ruleForm.reset();
    this.controller.view.dom.$saveButton.disabled = true;
    this.controller.assign = false;
    this.controller.ruleSetId = '';
    this.controller.editForm = false;
    this.controller.editId = '';
  }

  public assignAfterAdd(ruleSetId: string) {
    this.controller.assign = true;
    this.controller.ruleSetId = ruleSetId;
  }

  public setEdit(record: any): void {
    this.controller.view.dom.$ruleForm.setData(this.controller.dataRepository.convertRecord(record));
    this.controller.editForm = true;
    this.controller.editId = record._id;
  }

  get isVisible(): boolean | undefined {
    if (this.hasAttribute('data-is-visible')) {
      const value = this.getAttribute('data-is-visible');
      return value ? JSON.parse(value) : undefined;
    }

    return undefined;
  }

  set isVisible(value: boolean | undefined) {
    if (value) {
      this.setAttribute('data-is-visible', '');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }
}
